module.exports = __webpack_public_path__ + "static/media/S30_black.7213cbe4.png";